export default "__VITE_ASSET__2ee7053d__"